import React from 'react';
import PropTypes from "prop-types";
import css from "./ServiceWaitingRoom.css"
import {getWaitingTime, shouldDisplayWaitTime} from "../utils/waitingRoom";

const getWaitTimeText = (kioskMaxWaitTime) => {
  if (!kioskMaxWaitTime) return "";
  const { minutes, hours, days } = getWaitingTime(kioskMaxWaitTime);
  const daysText = `${days > 0 ? (days + 'd ') : ''}`;
  const hoursText = `${hours > 0 ? (hours + 'h ') : ''}`;
  const minutesText = `${minutes > 0 ? (minutes + 'm') : ''}`;
  return `${daysText}${hoursText}${minutesText} wait`;
}

const waitingRoomText = (kioskQueueSize, kioskMaxWaitTime) => {
  const queueSizeText = kioskQueueSize > 0 ? `${kioskQueueSize} in line` : "";
  const waitTimeText = getWaitTimeText(kioskMaxWaitTime)
  return `${queueSizeText}${waitTimeText && queueSizeText ? ',' : ''} ${waitTimeText}`
}

const ServiceWaitingRoom = (props) => {
  return shouldDisplayWaitTime(props.kioskQueueSize, props.kioskMaxWaitTime, props.kioskType) ?
    <div className={css['wait-time']}>
      <a href={"../kiosk/waitingRoom.html?kioskId=" + props.kioskId}>
        {waitingRoomText(props.kioskQueueSize, props.kioskMaxWaitTime)}
      </a>
    </div>
    : null;
};

ServiceWaitingRoom.propTypes = {
  kioskQueueSize: PropTypes.number,
  kioskMaxWaitTime: PropTypes.number,
  kioskId: PropTypes.number,
  kioskType: PropTypes.string
};

export default ServiceWaitingRoom;
